import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  BABYDOGE_ADDRESS,
  CHAINS,
  isValidEvmAddress,
} from './mockAnalyze';
import { useLang } from '../../i18n/context';
import ToolboxReturnPanel from '../../components/ToolboxReturnPanel';
import RebateBanner from '../../components/RebateBanner';
import './DumpDetectivePage.css';
import '../../styles/pro-page.css';

function DumpDetectivePage() {
  const navigate = useNavigate();
  const { t } = useLang();
  const [chain, setChain] = useState('bsc');
  const [address, setAddress] = useState('');
  const [error, setError] = useState('');

  const selectedChain = CHAINS.find((item) => item.key === chain);

  const submit = (event) => {
    event.preventDefault();
    setError('');

    if (!selectedChain?.enabled) {
      setError(t('detective.errorChainNotOpen'));
      return;
    }

    if (!isValidEvmAddress(address)) {
      setError(t('detective.errorInvalidAddress'));
      return;
    }

    navigate(`/dump-detective/report/${chain}/${address.toLowerCase()}`);
  };

  const useExample = () => {
    setChain('bsc');
    setAddress(BABYDOGE_ADDRESS);
    setError('');
  };

  return (
    <main className="pro-page">
      <div className="pro-page-inner">
        <button type="button" className="pro-back" onClick={() => navigate('/tools')}>{t('toolbox.backToTools')}</button>
        <header className="pro-hero">
          <p className="pro-hero-label">Dump Detective</p>
          <h1>{t('detective.title')}</h1>
          <span className="pro-hero-desc">{t('detective.description')}</span>
          <div className="dd-hero-meta">
            <span>Beta</span>
            <span>BSC / ETH / Base / SOL</span>
            {[t('detective.tagContract'), t('detective.tagLiquidity'), t('detective.tagHolders')].map((tag) => (
              <span key={tag}>{tag}</span>
            ))}
          </div>
        </header>

      <form className="dd-search-panel" onSubmit={submit}>
        <div className="dd-chain-grid" role="group" aria-label={t('detective.selectChain')}>
          {CHAINS.map((item) => (
            <button
              key={item.key}
              type="button"
              className={`dd-chain${chain === item.key ? ' active' : ''}`}
              disabled={!item.enabled}
              onClick={() => {
                setChain(item.key);
                if (!item.enabled) setError(t('detective.errorChainNotOpen'));
              }}
            >
              <strong>{item.label}</strong>
              <span>{item.enabled ? t('detective.available') : t('detective.notAvailable')}</span>
            </button>
          ))}
        </div>

        <label className="dd-address-field">
          <span>{t('detective.tokenContractAddress')}</span>
          <input
            value={address}
            onChange={(event) => setAddress(event.target.value)}
            placeholder="0x..."
            autoComplete="off"
          />
        </label>

        {error && <div className="dd-error" role="alert">{error}</div>}

        <div className="dd-actions">
          <button type="submit" className="dd-primary">{t('detective.startDetect')}</button>
          <button type="button" className="dd-secondary" onClick={useExample}>{t('detective.exampleBabyDoge')}</button>
        </div>
      </form>

      <section className="dd-footnote">
        {t('detective.footnote')}
      </section>

      <ToolboxReturnPanel
        className="dd-toolbox-return"
        description={t('detective.toolboxDescription')}
        links={[
          { label: t('detective.patternMatch'), href: '/pattern-match' },
          { label: t('detective.supportResistance'), href: '/support-resistance' },
        ]}
      />

      <RebateBanner />
      </div>
    </main>
  );
}

export default DumpDetectivePage;
